import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { replace } from 'react-router-redux';
import qs from 'qs';
import {
  Button,
  Container,
  Menu,
} from 'semantic-ui-react';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import NavBar from '../../components/NavBar';
import Form from './Form';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class New extends Component {
  static propTypes = {
    token: PropTypes.string,
    loading: PropTypes.bool,
    onCheck: PropTypes.func,
    type: PropTypes.string,
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      hasChanges: false,
    };
  }
  async submit(validations, preset) {
    const { store } = this.context;
    const { type, t } = this.props;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      return;
    }
    let res;
    const q = Object.assign({
      templateType: type,
    });
    try {
      res = await this.form.submit(`/templates/?${qs.stringify(q)}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(preset),
      });
    } catch (err) {
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.setState({ hasChanges: false }, () => {
      this.handleOnCheck(false, async (noChanges) => {
        if (noChanges) {
          const path = type === 'quotation' ? 'quotation_templates' : 'print_templates';
          store.dispatch(replace(`/settings/${path}/`));
          store.dispatch(flashSuccessMessage({ header: t('Create Success', { ns: TRANSLATION_FILES.translation }), message: t('{{name}} successfully created', { ns: TRANSLATION_FILES.translation, name: res.name }) }));
        }
      });
    });
  }
  handleSubmit = (event) => {
    this.form.handleSubmit(event);
  }
  handleOnChange = (hasChanges) => {
    if (hasChanges !== this.state.hasChanges) {
      this.setState({ hasChanges }, () => {
        this.handleOnCheck(hasChanges);
      });
    }
  }
  handleOnCheck = (hasChanges = false, callback) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges, callback);
    }
  }
  render() {
    const { t } = this.props;
    const headerLabel = this.props.type === 'quotation' ? 'Quotation' : 'Print';
    return (
      <Container>
        <NavBar
          header={t(`New ${headerLabel} Template`, { ns: TRANSLATION_FILES.translation })}
          rightNav={
            <Menu.Item fitted>
              <Button
                positive
                content={t('Create', { ns: TRANSLATION_FILES.screens })}
                onClick={this.handleSubmit}
                disabled={!this.state.hasChanges}
              />
            </Menu.Item>
          }
        />
        <Form
          ref={(ref) => { this.form = ref; }}
          onSubmit={(validations, preset) => {
            this.submit(validations, preset);
          }}
          onChange={this.handleOnChange}
          loading={this.props.loading}
          type={this.props.type}
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(New);



// WEBPACK FOOTER //
// ./src/containers/Templates/New.jsx